<template>
  <div>
    <h2 class="msg-head">{{ $t(options.title) }}</h2>
    <div class="msg-content">
      <img
        v-if="options.image && options.image === 'tip'"
        class="msg-logo"
        src="~img/warring-icon.svg"
        alt="warning message"
      />
      <img
        v-else
        class="msg-logo"
        src="@/components/BaseUi/MessageModal/image/message.svg"
        alt="success message"
      />
      <p v-for="(desc, index) in options.desc" :key="index">
        <i18n-t v-if="desc.need" :keypath="desc.content" tag="p">
          <span>{{ options.dragoncodeLast4 }}</span>
          <span>{{ options.visaCardLast4 }}</span>
        </i18n-t>
        <template v-else>
          {{ $t(desc.content) }}
        </template>
      </p>
      <button v-if="options.btnTitle" class="msg-button" @click="handleClick">{{ $t(options.btnTitle) }}</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MessagePage',

    props: {
      options: {
        type: Object,
        default: () => {},
      },
    },

    methods: {
      handleClick() {
        this.$emit('btnClick');
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use './index';
  @use './mobile';
</style>
